"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
const TileContent = /*#__PURE__*/React.forwardRef(({
  children,
  noPadding,
  withPointer,
  withBorder,
  useMargins = true
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _clsx.default)("text-normal leading-normal", withPointer === true && "cursor-pointer", withBorder === true && "border-cloud-normal border-t", !noPadding && !useMargins && "p-md lm:p-lg", !noPadding && useMargins && "py-md mx-md lm:py-lg lm:mx-lg")
  }, children);
});
var _default = TileContent;
exports.default = _default;